export default __webpack_public_path__ + "static/media/calendar.e17fb954.svg";